import React, { useState, useEffect } from "react";
import {
  TextField,
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
   MenuItem,
} from "@mui/material";
import SriyanshCardHeader from "../../components/CardHeader";
import DropdownfromDatabaseList from "../../CustomComponant/DropdownfromDatabaseList";
import apiClient from "../../BaseUrl/apiClient.js";
import TokenService from "../../service/TokenService";
import EncryptService from "../../service/EncryptionService";
import { useNavigate } from "react-router-dom";

function UpdateUser() {
  const [role, setRole] = useState("");
  const [roles, setRoles] = useState([]);
  const [list1, setList1] = useState([]);
  const [list2, setList2] = useState([]);
  const [fname, setfName] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [errors, setErrors] = useState({});
  const [consignee, setConsignee] = useState("");
  const [consignees, setConsignees] = useState([]);
  const [updateBtn, setUpdateBtn] = useState(true);
const [userStatus, setUserStatus] = useState(1);
  const navigate = useNavigate();
  const tokenServiceDetails = TokenService.getUserDetails();
  const logineuname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));

  const sortItems = (items) =>
    [...items].sort((a, b) => a.Shop.localeCompare(b.Shop));

  const handleTransferToSelected = (item) => {
    const updatedList1 = list1.filter(
      (i) => i.ConsigneeCode !== item.ConsigneeCode
    );
    const updatedList2 = [...list2, item];
    setList1(sortItems(updatedList1));
    setList2(sortItems(updatedList2));
  };

  const handleTransferToAvailable = (item) => {
    const updatedList2 = list2.filter(
      (i) => i.ConsigneeCode !== item.ConsigneeCode
    );
    const updatedList1 = [...list1, item];
    setList1(sortItems(updatedList1));
    setList2(sortItems(updatedList2));
  };

  const fetchConsignees = async () => {
    try {
      const response = await apiClient.post("/ConsigneeList");
      setConsignees(response.data);
      setList1(response.data);
    } catch (error) {
      console.error("Error Fetching Consignee:", error);
    }
  };
  const toProperCase = (str) =>
    str
      .replace(/^\s+/, "") // Remove leading spaces
      .replace(/\s+/g, " ")
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ")
      ;
  const fetchRoles = async () => {
    try {
      const response = await apiClient.post("/roleList");
      setRoles(response.data);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const fetchUserData = () => {
    apiClient
      .post("/getUserData", { uname: logineuname, userName1: username })
      .then((response) => {
        const consigneeCodes = response.data[0]?.consignee;

        if (!consigneeCodes) {
          //console.error("ConsigneeCode is undefined or empty");
          return;
        }

        const selectedCodes = consigneeCodes.split(",");

        apiClient
          .post("/ConsigneeList")
          .then((response) => {
            const list1 = response.data;

            // Filter items based on selected codes
            const filteredData = list1.filter((item) =>
              selectedCodes.includes(item?.ConsigneeCode?.toString())
            );
            setList2(filteredData);

            // Remove items in selectedCodes from list1
            const updatedList1 = list1.filter(
              (item) => !selectedCodes.includes(item?.ConsigneeCode?.toString())
            );
            setList1(updatedList1);
          })
          .catch((error) =>
            console.error("Error fetching ConsigneeList:", error)
          );
      })
      .catch((error) => {
        if (error.code === "ERR_BAD_REQUEST") {
          alert("Invalid User Name");
          setUpdateBtn(true);
        } else {
          console.error("Error fetching user data:", error);
        }
      });
  };

  const getUserData = async () => {
    try {
      const response = await apiClient.post("/getUserData", {
        uname: logineuname,
        userName1: username,
      });
      const data = response.data[0];
      setEmail(data.emailid);
      setMobileNumber(data.mobilenumber);
      setfName(data.FullName);
      setRole(data.userrights);
      setUserStatus(Number(data.activestatus));
      setConsignee(data.consignee ? data.consignee : "");
      setUpdateBtn(false);
    } catch (error) {
      setfName("");
      setEmail("");
      setMobileNumber("");
      setUserStatus("");
      setUpdateBtn(true);
    }
  };

  useEffect(() => {
    fetchConsignees();
    fetchRoles();
  }, []);

  useEffect(() => {
    if (consignees.length > 0) {
      setConsignee(
        consignees[0].ConsigneeCode ? consignees[0].ConsigneeCode : ""
      );
    }
    if (roles.length > 0) {
      setRole(roles[2]?.id);
    }
  }, [consignees, roles, username]);

  const handleMobileNumberChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setMobileNumber(value);
    }
  };

  const UpdatOldUser = async (e) => {

if (username.trim().toLowerCase() === "amit") {
  alert("Super User cannot be changed.");
  return;
}


    e.preventDefault();
    let formErrors = {};
    if (!fname) formErrors.name = "Name is required";
    if (!email) formErrors.email = "Email is required";
    if (!username) formErrors.username = "Username is required";
    if (!mobileNumber) formErrors.mobileNumber = "Mobile number is required";
    if (mobileNumber && mobileNumber.length !== 10)
      formErrors.mobileNumber = "Mobile number must be 10 digits";
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailPattern.test(email)) {
      formErrors.email = "Email is invalid";
    }
    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const itemCodes =
        list2.length > 0
          ? list2.map((item) => item.ConsigneeCode).join(",")
          : "91145"; // Only generate itemCodes if list2 is not empty


          const vconsignee1 =
          ((role === 3 || role === 4 || role === 6) && itemCodes) ? itemCodes : (consignee || "91145");
console.log(userStatus);
    

      try {
        await apiClient.post("/updateUser", {
          uname: username,
          rights: role,
          fname: fname,
          email: email,
          mobile: mobileNumber,
          cretedby: logineuname,
          vip: ip,
          vconsignee: vconsignee1,
          userstatus: Number(userStatus),
        });
        setfName("");
        setEmail("");
        setMobileNumber("");
        setUsername("");
        setUserStatus(1);
        if (roles.length > 0) {
          setRole(roles[2]?.role);
        }
      } catch (error) {
         console.log(error.response);
  console.log(error.response?.data);
      }
    }
  };

  const handleClose = () => {
    navigate("../", { replace: true });
  };


 const handleChange = (e) => {
    // Checked = Not Activated (1)
    // Unchecked = Activated (0)
    setUserStatus(e.target.checked ? 1 : 0);
  };




return (
  <Box
    className="update-user-page"
    sx={{
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
      boxSizing: "border-box",
      px: { xs: 0.75, sm: 1.25, md: 2 },
      py: { xs: 0.75, sm: 1, md: 1.5 },
      overflowX: "hidden",
    }}
  >
    <Card
      className="update-user-card"
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        overflow: "hidden",
        borderRadius: { xs: 2, md: 3 },
        border: "1px solid #dbe5f1",
        background: "#fff",
        boxShadow: "0 8px 28px rgba(13, 71, 161, 0.10)",
      }}
    >
      {/* ================= HEADER ================= */}
      <Box
        sx={{
          background:
            "linear-gradient(135deg, #0D47A1 0%, #1565C0 50%, #1976D2 100%)",
          color: "#fff",
          px: { xs: 1.5, sm: 2, md: 2.5 },
          py: { xs: 1.3, sm: 1.5, md: 1.7 },
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: "1rem",
              sm: "1.1rem",
              md: "1.25rem",
            },
            fontWeight: 700,
            lineHeight: 1.3,
          }}
        >
          Update User
        </Typography>
      </Box>

      <CardContent
        sx={{
          p: { xs: 1, sm: 1.5, md: 2 },
          "&:last-child": {
            pb: { xs: 1.5, sm: 2, md: 2.5 },
          },
        }}
      >
        {/* ================= USER INFORMATION ================= */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            border: "1px solid #dbe5f1",
            borderRadius: 2,
            background: "#fff",
            p: { xs: 1.25, sm: 1.5, md: 2 },
            mb: { xs: 1.5, md: 2 },
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: "0.9rem",
                sm: "0.95rem",
                md: "1rem",
              },
              fontWeight: 700,
              color: "#0D47A1",
              mb: { xs: 1.25, sm: 1.5 },
              pl: 1,
              borderLeft: "4px solid #1976D2",
              lineHeight: 1.4,
            }}
          >
            User Information
          </Typography>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "1fr 1fr",
                md: "1fr 1fr 1fr",
              },
              gap: { xs: 1.5, sm: 2, md: 2.5 },
              width: "100%",
              minWidth: 0,
            }}
          >
            {/* USER ID */}
            <Box sx={{ width: "100%", minWidth: 0 }}>
              <TextField
                label="User ID"
                variant="outlined"
                size="small"
                value={username}
                onChange={(e) =>
                  setUsername(e.target.value.toLowerCase())
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    getUserData();
                    fetchUserData();
                  }
                }}
                fullWidth
                error={!!errors.username}
                helperText={
                  errors.username ||
                  "Press Enter to load user"
                }
                inputProps={{ maxLength: 10 }}
              />
            </Box>

            {/* EMAIL */}
            <Box sx={{ width: "100%", minWidth: 0 }}>
              <TextField
                label="Email"
                size="small"
                variant="outlined"
                type="email"
                value={email}
                onChange={(e) =>
                  setEmail(e.target.value.toLowerCase())
                }
                fullWidth
                error={!!errors.email}
                helperText={errors.email}
                inputProps={{ maxLength: 50 }}
              />
            </Box>

            {/* FULL NAME */}
            <Box sx={{ width: "100%", minWidth: 0 }}>
              <TextField
                label="Full Name"
                variant="outlined"
                size="small"
                value={fname}
                onChange={(e) =>
                  setfName(toProperCase(e.target.value))
                }
                fullWidth
                error={!!errors.fname}
                helperText={errors.fname}
                inputProps={{ maxLength: 30 }}
              />
            </Box>

            {/* MOBILE */}
            <Box sx={{ width: "100%", minWidth: 0 }}>
              <TextField
                label="Mobile Number"
                variant="outlined"
                type="tel"
                size="small"
                value={mobileNumber}
                onChange={handleMobileNumberChange}
                fullWidth
                error={!!errors.mobileNumber}
                helperText={errors.mobileNumber}
                inputProps={{
                  maxLength: 10,
                  pattern: "[0-9]*",
                }}
              />
            </Box>

            {/* ROLE */}
            <Box sx={{ width: "100%", minWidth: 0 }}>
              <DropdownfromDatabaseList
                size="small"
                Options={roles}
                option={role}
                setOptionValue={setRole}
                DisplayItem1="role"
                DisplayItem2="id"
              />
            </Box>

            {/* USER STATUS */}
            <Box sx={{ width: "100%", minWidth: 0 }}>
              <TextField
                select
                fullWidth
                size="small"
                label="User Status"
                value={userStatus}
                onChange={(e) =>
                  setUserStatus(
                    Number(e.target.value)
                  )
                }
              >
                <MenuItem value={0}>
                  Activated
                </MenuItem>

                <MenuItem value={1}>
                  Not Activated
                </MenuItem>
              </TextField>
            </Box>
          </Box>
        </Box>

        {/* =====================================================
            CONSIGNEE SELECTION FOR ROLES 3, 4, 6
            ===================================================== */}
        {(role === 3 || role === 4 || role === 6) && (
          <Box
            sx={{
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              border: "1px solid #dbe5f1",
              borderRadius: 2,
              background: "#fff",
              p: { xs: 1.25, sm: 1.5, md: 2 },
              mb: { xs: 1.5, md: 2 },
            }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: "0.9rem",
                  sm: "0.95rem",
                  md: "1rem",
                },
                fontWeight: 700,
                color: "#0D47A1",
                mb: { xs: 1.25, sm: 1.5 },
                pl: 1,
                borderLeft: "4px solid #1976D2",
              }}
            >
              Consignee Selection
            </Typography>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  md: "1fr 1fr",
                },
                gap: { xs: 1.5, md: 2 },
                width: "100%",
                minWidth: 0,
              }}
            >
              {/* AVAILABLE CONSIGNEES */}
              <Box
                sx={{
                  width: "100%",
                  minWidth: 0,
                  border: "1px solid #c9d8eb",
                  borderRadius: 2,
                  overflow: "hidden",
                  background: "#f8fbff",
                }}
              >
                <Box
                  sx={{
                    background:
                      "linear-gradient(135deg, #1565C0, #1976D2)",
                    color: "#fff",
                    px: 1.5,
                    py: 1,
                    textAlign: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "0.85rem",
                        sm: "0.95rem",
                      },
                      fontWeight: 700,
                    }}
                  >
                    Available Consignees
                  </Typography>
                </Box>

                <Box
                  sx={{
                    maxHeight: 300,
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                >
                  <List disablePadding>
                    {list1.map((item) => (
                      <ListItem
                        key={item.ConsigneeCode}
                        button
                        onClick={() =>
                          handleTransferToSelected(item)
                        }
                        sx={{
                          borderBottom:
                            "1px solid #e5edf7",
                          px: { xs: 1, sm: 1.5 },
                          py: 0.8,
                          cursor: "pointer",

                          "&:hover": {
                            background: "#e3f2fd",
                          },
                        }}
                      >
                        <ListItemText
                          primary={item.Shop}
                          secondary={item.ConsigneeCode}
                          primaryTypographyProps={{
                            fontSize: {
                              xs: "0.82rem",
                              sm: "0.9rem",
                            },
                            fontWeight: 600,
                            sx: {
                              overflowWrap: "anywhere",
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                            },
                          }}
                          secondaryTypographyProps={{
                            fontSize: {
                              xs: "0.72rem",
                              sm: "0.78rem",
                            },
                            sx: {
                              overflowWrap: "anywhere",
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                            },
                          }}
                        />
                      </ListItem>
                    ))}

                    {list1.length === 0 && (
                      <Box
                        sx={{
                          py: 3,
                          textAlign: "center",
                          color: "#78909c",
                        }}
                      >
                        <Typography variant="body2">
                          No available consignee
                        </Typography>
                      </Box>
                    )}
                  </List>
                </Box>
              </Box>

              {/* SELECTED CONSIGNEES */}
              <Box
                sx={{
                  width: "100%",
                  minWidth: 0,
                  border: "1px solid #c9d8eb",
                  borderRadius: 2,
                  overflow: "hidden",
                  background: "#f8fbff",
                }}
              >
                <Box
                  sx={{
                    background:
                      "linear-gradient(135deg, #0D47A1, #1565C0)",
                    color: "#fff",
                    px: 1.5,
                    py: 1,
                    textAlign: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "0.85rem",
                        sm: "0.95rem",
                      },
                      fontWeight: 700,
                    }}
                  >
                    Selected Consignees
                  </Typography>
                </Box>

                <Box
                  sx={{
                    maxHeight: 300,
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                >
                  <List disablePadding>
                    {list2.map((item) => (
                      <ListItem
                        key={item.ConsigneeCode}
                        button
                        onClick={() =>
                          handleTransferToAvailable(item)
                        }
                        sx={{
                          borderBottom:
                            "1px solid #e5edf7",
                          px: { xs: 1, sm: 1.5 },
                          py: 0.8,
                          cursor: "pointer",

                          "&:hover": {
                            background: "#e3f2fd",
                          },
                        }}
                      >
                        <ListItemText
                          primary={item.Shop}
                          secondary={item.ConsigneeCode}
                          primaryTypographyProps={{
                            fontSize: {
                              xs: "0.82rem",
                              sm: "0.9rem",
                            },
                            fontWeight: 600,
                            sx: {
                              overflowWrap: "anywhere",
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                            },
                          }}
                          secondaryTypographyProps={{
                            fontSize: {
                              xs: "0.72rem",
                              sm: "0.78rem",
                            },
                            sx: {
                              overflowWrap: "anywhere",
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                            },
                          }}
                        />
                      </ListItem>
                    ))}

                    {list2.length === 0 && (
                      <Box
                        sx={{
                          py: 3,
                          textAlign: "center",
                          color: "#78909c",
                        }}
                      >
                        <Typography variant="body2">
                          No selected consignee
                        </Typography>
                      </Box>
                    )}
                  </List>
                </Box>
              </Box>
            </Box>
          </Box>
        )}

        {/* =====================================================
            ROLE 2 CONSIGNEE
            ===================================================== */}
        {role === 2 && (
          <Box
            sx={{
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              border: "1px solid #dbe5f1",
              borderRadius: 2,
              background: "#fff",
              p: { xs: 1.25, sm: 1.5, md: 2 },
              mb: { xs: 1.5, md: 2 },
            }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: "0.9rem",
                  sm: "0.95rem",
                  md: "1rem",
                },
                fontWeight: 700,
                color: "#0D47A1",
                mb: 1.5,
                pl: 1,
                borderLeft: "4px solid #1976D2",
              }}
            >
              Consignee
            </Typography>

            <Box
              sx={{
                width: "100%",
                minWidth: 0,
              }}
            >
              <DropdownfromDatabaseList
                Options={consignees}
                option={consignee}
                setOptionValue={setConsignee}
                DisplayItem1="Shop"
                DisplayItem2="ConsigneeCode"
                showKeyInLabel={true}
              />
            </Box>
          </Box>
        )}

        {/* ================= ACTION BUTTONS ================= */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
            },
            gap: { xs: 1, sm: 1.5, md: 2 },
            mt: { xs: 1, md: 1.5 },
          }}
        >
          <button
            type="button"
            onClick={UpdatOldUser}
            title="Click for user update"
            disabled={updateBtn}
            className="update-action-btn update-btn"
          >
            Update Login
          </button>

          <button
            type="button"
            onClick={handleClose}
            title="Close"
            className="update-action-btn update-close-btn"
          >
            Close
          </button>
        </Box>
      </CardContent>
    </Card>

    {/* ================= RESPONSIVE CSS ================= */}
    <style>{`
      .update-user-page,
      .update-user-page * {
        box-sizing: border-box;
      }

      .update-user-page {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        overflow-x: hidden;
      }

      .update-user-card {
        width: 100%;
        max-width: 100%;
        min-width: 0;
      }

      /* ================= FORM FIELDS ================= */

      .update-user-card .MuiFormControl-root,
      .update-user-card .MuiTextField-root {
        width: 100%;
        max-width: 100%;
        min-width: 0;
      }

      /* ================= LIST ================= */

      .update-user-card .MuiListItemText-root {
        min-width: 0;
      }

      .update-user-card .MuiListItemText-primary,
      .update-user-card .MuiListItemText-secondary {
        white-space: normal !important;
        overflow-wrap: anywhere !important;
        word-break: break-word !important;
      }

      /* ================= BUTTONS ================= */

      .update-action-btn {
        width: 100%;
        min-height: 44px;
        border: none;
        border-radius: 8px;
        padding: 10px 16px;
        color: #fff;
        font-size: 0.9rem;
        font-weight: 700;
        cursor: pointer;

        transition:
          transform 0.18s ease,
          box-shadow 0.18s ease,
          opacity 0.18s ease;
      }

      .update-btn {
        background:
          linear-gradient(
            135deg,
            #1565C0 0%,
            #1976D2 100%
          );

        box-shadow:
          0 4px 12px rgba(21, 101, 192, 0.25);
      }

      .update-close-btn {
        background:
          linear-gradient(
            135deg,
            #c62828 0%,
            #e53935 100%
          );

        box-shadow:
          0 4px 12px rgba(198, 40, 40, 0.20);
      }

      .update-action-btn:not(:disabled):hover {
        transform: translateY(-1px);
      }

      .update-action-btn:not(:disabled):active {
        transform: translateY(0);
      }

      .update-action-btn:disabled {
        background: #b0bec5 !important;
        color: #fff;
        cursor: not-allowed;
        box-shadow: none;
        opacity: 0.85;
      }

      /* ================= TABLET ================= */

      @media (max-width: 900px) {
        .update-user-card {
          border-radius: 12px;
        }
      }

      /* ================= MOBILE ================= */

      @media (max-width: 600px) {
        .update-user-page {
          padding-left: 4px !important;
          padding-right: 4px !important;
        }

        .update-user-card {
          border-radius: 10px !important;
        }

        .update-action-btn {
          min-height: 42px;
          font-size: 0.85rem;
        }
      }

      /* ================= SMALL MOBILE ================= */

      @media (max-width: 400px) {
        .update-action-btn {
          min-height: 40px;
          font-size: 0.82rem;
        }
      }
    `}</style>
  </Box>
);
}

export default UpdateUser;
